import * as util from '../apiUtils';
import * as common from '../apiCommon';
import * as DocType from '../../constants/constant_doc_types';


export function fetchAttributeValueDropdown(app, params) {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = 'attribute_value/dropdown';
  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams
  };

  return common.getDropdownList(app, { query });
}

export function fetchAttributeNameDropdown(app, params) {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = 'attribute_name/dropdown';

  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams
  };

  return common.getDropdownList(app, { query });
}

export function fetchItemMatrixAttributeDropdown(app, itemIds, params) {
  const { searchTerm, searchParams, fields, id } = params || {};
  const dropdown_type = 'item_matrix_attribute/dropdown';
  
  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams,
    itemIds
  };

  return common.getDropdownList(app, { query });
}

export function deleteMatrixAttribute(app, params) {
  const { id } = params;
  const docType = 'item_matrix_attribute';
  return common.deleteDoc(app, { id, docType });
}

export function saveMatrixAttribute(app, dataToSave) {
  const { user = {}, data } = dataToSave;

  let matrixAttributeData = {
    doc_type: DocType.ITEM_MATRIX_ATTRIBUTE,
    name: util.toStringText(data.name),
    active: util.toBoolean(data.active),
    attributes: data.attributes || []
  };
  return common.saveDoc(app, {
    source: data,
    doc: matrixAttributeData,
    user
  });
}

export async function fetchMatrixAttributeById(app, params) {
  const { id } = params;
  const docType = 'item_matrix_attribute';
  const { is_used } = await common.queryDocs(app, 'item/validate-matrix-definition', { matrix_definition_id: id } );
  const doc = await common.getDoc(app, { id, docType });
  doc.is_used = is_used;
  return doc;
}


export function fetchParentItemsMatrixDef(app, params) {
  const { id } = params;
  const service = common.getAccountService(app, DocType.ITEM);
  const options = {
    selector: {
      doc_type: DocType.ITEM,
      parent: null,
      "matrix_definition._id": id
    },
    limit: 10000,
    // profile: app.get('user_info')
  }
  return service.find({ query: options });
}
